import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { formatPhoneNumber } from '../utils/Common';    
import packaged4cam from '../images/packaged-4cam-system.jpg';
import packaged2cam from '../images/packaged-2cam-system.jpg';
import packagedlegacy from '../images/packaged_camera_system.jpg';
import styled from 'styled-components';
import AddressDisplay from './AddressDisplay';

const ReturnImage = styled.img`
  display: block;
  margin: 20px auto;
  max-width: 100%;
  height: auto;
`;

export default function CancelServiceModal({ show, onHide, cap, stripeCustomer, builderId }) {
  const [step, setStep] = useState(1);
  const [hasOriginalBox, setHasOriginalBox] = useState(null);
  const [hasReturnLabel, setHasReturnLabel] = useState(null);
  const [shippingAddress, setShippingAddress] = useState(null);
  const [isEditingAddress, setIsEditingAddress] = useState(false);
  const [returnImage, setReturnImage] = useState(packagedlegacy);

  useEffect(() => {
    if (stripeCustomer?.shipping) {
      const shippingName = stripeCustomer.shipping.name;
      const companyName = stripeCustomer.metadata?.company_name || shippingName;
      const phone = formatPhoneNumber(stripeCustomer.phone);
      
      setShippingAddress({
        company: companyName !== shippingName ? companyName : null,
        name: shippingName,
        phone,
        street: stripeCustomer.shipping.address.line1,
        city: stripeCustomer.shipping.address.city,
        state: stripeCustomer.shipping.address.state,
        zip: stripeCustomer.shipping.address.postal_code
      });
    }
  }, [stripeCustomer]);

  useEffect(() => {
    if(cap && cap.architecture.includes("4CAM")) {
        setReturnImage(packaged4cam);
    } else if(cap && cap.architecture.includes("2CAM")) {
        setReturnImage(packaged2cam);
    } else {
        setReturnImage(packagedlegacy);
    }
  }, [cap]);

  const handleClose = () => {
    setStep(1);
    setHasOriginalBox(null);
    setHasReturnLabel(null);
    onHide();
  };

  const handleGenerateLabel = async () => {
    // Placeholder API call
    // TODO TODO TODO - Make the label with shippo and then email me to say that they've requested a return label
    console.log('Generating return label for cap:', cap.capid);
    return 'https://example.com/return-label.pdf';
  };

  const requestReturnPackaging = async () => {
    // Placeholder API call
    // TODO TODO TODO - Maybe just email me 
    console.log('Requesting return label for cap:', cap.capid);
    setStep(4);
  };

  const handleCustomerReturn = async () => {
    // TODO TODO TODO - Send me an email to say the customer is returning the system
    console.log('Customer is returning the system:', cap.capid);
    setHasReturnLabel(true);
    setStep(4);
  };
  
  const ReturnInstructions = () => {
    return (
        <div>
          <h4 className="modal-step-title">Please follow these steps to return your camera system</h4>
          <ol className="modal-step-list">
            <li>Place the camera system in the return packaging</li>
            <li>Use the provided foam to secure the system</li>
            <li>We do not need any of the original hardware or the sign, just the camera system</li>
            <li>Place the return label over the old return label on the outside of the box</li>
            <li>Tape up the box, sometimes FedEx will do this for you</li>
            <li>Drop it off at your nearest FedEx location</li>
          </ol>
          <p className="modal-step-description">Once FedEx receives the system, we will cancel your subscription and you will no longer be charged.</p>
          <ReturnImage src={returnImage} alt="Return Packaging" />
          
        </div>
      );
  };

  const renderStep1 = () => (
    <div>
      <h4 className="modal-step-title">Service Cancellation Disclaimer</h4>
      <p className="modal-step-description">
        Please note that your subscription for this unit will not be cancelled until the system has been returned to FedEx with the proper return label and packaging.
      </p>
      <p className="modal-step-description">
        You can retrieve a new label here and request a new return box if needed.
      </p>
      <div className="modal-footer">
        <Button onClick={() => setStep(2)}>I Understand</Button>
      </div>
    </div>
  );

  const renderStep2 = () => (
    <div>
      <h4 className="modal-step-title">Original Packaging</h4>
      <p className="modal-step-description">Do you have your original box and shipping foam and are they in good condition for returning the camera system?</p>
      <div className="modal-footer">
        {/* <Button onClick={() => setStep(1)}>Back</Button> */}
        <Button onClick={() => {
          setHasOriginalBox(true);
          setStep(3);
        }}>Yes</Button>
        <Button onClick={() => {
          setHasOriginalBox(false);
          setStep(3);
        }}>No</Button>
      </div>
    </div>
  );

  const renderStep3 = () => {
    if (hasOriginalBox) {
      return (
        <div>
          <h4 className="modal-step-title">Return Label</h4>
          <p className="modal-step-description">Do you have the return label sticker that was included in the instruction packet?</p>
          <div className="modal-footer">
            <Button onClick={() => setStep(2)}>Back</Button>
            <Button onClick={() => {
              handleCustomerReturn();
            }}>Yes</Button>
            <Button onClick={() => {
              setHasReturnLabel(false);
              setStep(4);
            }}>No</Button>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <h4 className="modal-step-title">Shipping Address</h4>
          <p className="modal-step-description">Please confirm if we can send return packaging to this address:</p>
          {shippingAddress ? (
            <AddressDisplay
              address={shippingAddress}
              setShippingAddress={setShippingAddress}
              isEditingAddress={isEditingAddress}
              setIsEditingAddress={setIsEditingAddress}
              builderId={builderId}
            />
          ) : (
            <p className="modal-step-description">No shipping address found. Please update your billing information in your account settings.</p>
          )}
          <div className="modal-footer">
            <Button onClick={() => setStep(2)}>Back</Button>
            <Button onClick={() => requestReturnPackaging()} disabled={!shippingAddress || isEditingAddress}>Confirm Address</Button>
          </div>
        </div>
      );
    }
  };

  const renderStep4 = () => {
    if (hasOriginalBox && hasReturnLabel) {
      return (
        <div>
          <ReturnInstructions />
          <div className="modal-footer">
            <Button onClick={() => setStep(3)}>Back</Button>
            <Button onClick={handleClose}>Close</Button>
          </div>
        </div>
      );
    } else if (hasOriginalBox && !hasReturnLabel) {
      return (
        <div>
          <h4 className="modal-step-title">Generate Return Label</h4>
          <p className="modal-step-description">Is your shipping address correct?</p>
          <AddressDisplay
            address={shippingAddress}
            setShippingAddress={setShippingAddress}
            isEditingAddress={isEditingAddress}
            setIsEditingAddress={setIsEditingAddress}
            builderId={builderId}
          />
          <div className="modal-footer">
            <Button onClick={() => setStep(3)}>Back</Button>
            <Button onClick={async () => {
              const labelUrl = await handleGenerateLabel();
              window.open(labelUrl, '_blank');
              setHasReturnLabel(true);
            }} disabled={!shippingAddress || isEditingAddress}>Generate Label</Button>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <h4 className="modal-step-title">You've requested new return packaging</h4>
          <p className="modal-step-description">We're processing your request and will send you return packaging with an included return label. This may take up to 14 business days to arrive. </p>
          <ReturnInstructions />    
          <div className="modal-footer">
            <Button onClick={() => setStep(3)}>Back</Button>
            <Button onClick={handleClose}>Close</Button>
          </div>
        </div>
      );
    }
  };

  return (
    <Modal 
      show={show} 
      onHide={handleClose} 
      size="lg" 
      className="camera-modal"
      enforceFocus={false}
      restoreFocus={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Cancel Service - {cap?.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {step === 1 && renderStep1()}
        {step === 2 && renderStep2()}
        {step === 3 && renderStep3()}
        {step === 4 && renderStep4()}
      </Modal.Body>
    </Modal>
  );
} 